import { get, keys, map } from 'lodash';
import * as Constants from '../../constants';

const resetState = {
  isError: false,
  errors: [],
};

const initialState = {
  ...resetState,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case Constants.APP_RESET:
      return {
        ...state,
        ...resetState,
        details: {},
        fetchResult: Constants.NONE,
        createResult: Constants.NONE,
        deleteResult: Constants.NONE,
        updateResult: Constants.NONE,
        templateCategoriesDetailsMap: {},
        templatesUpdateResult: Constants.NONE,
        templatesOrderUpdateResult: Constants.NONE,
        isAllCategoriesTemplatesLoaded: false,
        isAPIApplicableTemplateCategoriesLoaded: false,
        isTemplateCategoriesLoaded: false,
      };
    case Constants.TEMPLATE_CATEGORY_GET_REQUEST:
      return {
        ...state,
        details: {},
        fetchResult: Constants.NONE,
        isLoading: true,
        validationErrors: [],
      };
    case Constants.TEMPLATE_CATEGORY_GET_SUCCESS:
      return {
        ...state,
        details: action.payload,
        fetchResult: Constants.SUCCESS,
        isLoading: false,
      };
    case Constants.TEMPLATE_CATEGORY_GET_ERROR:
      return {
        ...state,
        fetchResult: Constants.FAIL,
        isLoading: false,
        validationErrors: action.payload,
      };
    case Constants.TEMPLATE_CATEGORY_POST_REQUEST:
      return {
        ...state,
        createdTC: {},
        createResult: Constants.NONE,
        isLoading: true,
        validationErrors: [],
      };
    case Constants.TEMPLATE_CATEGORY_POST_SUCCESS:
      return {
        ...state,
        createdTC: action.payload,
        createResult: Constants.SUCCESS,
        isLoading: false,
      };
    case Constants.TEMPLATE_CATEGORY_POST_ERROR:
      return {
        ...state,
        createResult: Constants.FAIL,
        isLoading: false,
        validationErrors: action.payload,
      };
    case Constants.TEMPLATE_CATEGORY_PUT_REQUEST:
      return {
        ...state,
        isLoading: true,
        updateResult: Constants.NONE,
        validationErrors: [],
      };
    case Constants.TEMPLATE_CATEGORY_PUT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        updateResult: Constants.SUCCESS,
      };
    case Constants.TEMPLATE_CATEGORY_PUT_ERROR:
      return {
        ...state,
        isLoading: false,
        updateResult: Constants.FAIL,
        validationErrors: action.payload,
      };
    case Constants.TEMPLATE_CATEGORY_DELETE_REQUEST:
      return {
        ...state,
        deleteResult: Constants.NONE,
        isLoading: true,
        validationErrors: [],
      };
    case Constants.TEMPLATE_CATEGORY_DELETE_SUCCESS:
      return {
        ...state,
        deleteResult: Constants.SUCCESS,
        isLoading: false,
      };
    case Constants.TEMPLATE_CATEGORY_DELETE_ERROR:
      return {
        ...state,
        deleteResult: Constants.FAIL,
        isLoading: false,
        validationErrors: action.payload,
      };
    case Constants.TEMPLATES_GET_REQUEST:
      return {
        ...state,
        isLoading: true,
        policyTemplates: [],
        validationErrors: [],
      };
    case Constants.TEMPLATES_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        policyTemplates: get(action, 'payload.policyTemplates', []),
      };
    case Constants.TEMPLATES_GET_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case Constants.TEMPLATE_CATEGORY_TEMPLATES_GET_REQUEST:
      return {
        ...state,
        isLoading: true,
        isAllCategoriesTemplatesLoaded: false,
        categoryTemplates: [],
        categoriesTemplatesMap: {},
        validationErrors: [],
      };
    case Constants.TEMPLATE_CATEGORY_TEMPLATES_GET_SUCCESS: {
      const categoryUuid = get(action, 'categoryUuid');
      const allCategoriesIds = get(action, 'allCategoriesIds', []);
      const loadedCategoriesIds = keys(state.categoriesTemplatesMap);
      let isAllCategoriesTemplatesLoaded = state.isAllCategoriesTemplatesLoaded;
      if (!isAllCategoriesTemplatesLoaded &&
        (allCategoriesIds.length - 1 === loadedCategoriesIds.length)) {
          isAllCategoriesTemplatesLoaded = true;
      }
      const templates = get(action, 'payload', []);
      const updatedTemplates = map(templates, template => {
        const args = template.arguments;
        const updatedArgs = map(args, arg => ({
          ...arg,
          // Currently, we are not storing any flag with template
          // to denote whether a flag is required or not.
          // Only mechanism to determine whether a flag is required or not
          // is to check whether it ends with an asterick(*)
          required: arg.label && arg.label.endsWith('*'),
          // Policies with field name starting with l7.secure needs to be masked.
          //  To distinguish these fields, adding "secure" flag to arguments.
          secure: arg.name && arg.name.includes('l7.secure'),
        }));
        template.arguments = updatedArgs;
        return template;
      })

      return {
        ...state,
        isAllCategoriesTemplatesLoaded,
        isLoading: false,
        categoryTemplates: get(action, 'payload', []),
        categoriesTemplatesMap: {
          ...state.categoriesTemplatesMap,
          [categoryUuid]: updatedTemplates,
        },
      };
    }
    case Constants.TEMPLATE_CATEGORY_TEMPLATES_GET_ERROR: {
      const categoryUuid = get(action, 'categoryUuid');
      const allCategoriesIds = get(action, 'allCategoriesIds', []);
      const loadedCategoriesIds = keys(state.categoriesTemplatesMap);
      let isAllCategoriesTemplatesLoaded = state.isAllCategoriesTemplatesLoaded;
      if (!isAllCategoriesTemplatesLoaded &&
        (allCategoriesIds.length - 1 === loadedCategoriesIds.length)) {
          isAllCategoriesTemplatesLoaded = true;
      }
      return {
        ...state,
        isAllCategoriesTemplatesLoaded,
        isLoading: false,
        categoryTemplates: [],
        categoriesTemplatesMap: {
          ...state.categoriesTemplatesMap,
          [categoryUuid]: [],
        },
        validationErrors: action.payload,
      };
    }
    case Constants.TEMPLATE_CATEGORY_TEMPLATES_UPDATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        templatesUpdateResult: Constants.NONE,
        validationErrors: [],
      };
    case Constants.TEMPLATE_CATEGORY_TEMPLATES_UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        templatesUpdateResult: Constants.SUCCESS,
      };
    case Constants.TEMPLATE_CATEGORY_TEMPLATES_UPDATE_ERROR:
      return {
        ...state,
        isLoading: false,
        templatesUpdateResult: Constants.FAIL,
        validationErrors: action.payload,
      };
    case Constants.TEMPLATE_CATEGORY_APIS_ACCESS_GET_REQUEST:
      return {
        ...state,
        isLoading: true,
        categoryApis: [],
        validationErrors: [],
      };
    case Constants.TEMPLATE_CATEGORY_APIS_ACCESS_GET_SUCCESS: {
      const categoryUuid = get(action, 'categoryUuid');
      const categoryApis = get(action, 'payload', {});
      return {
        ...state,
        categoryApis,
        categoryUuid,
        errors: [],
        isCategoryApisError: false,
        isLoading: false,
      };
    }
    case Constants.TEMPLATE_CATEGORY_APIS_ACCESS_GET_ERROR: {
      return {
        ...state,
        isLoading: false,
        isCategoryApisError: true,
        categoryApis: [],
        validationErrors: action.payload,
      };
    }
    case Constants.TEMPLATE_CATEGORY_APIS_ACCESS_ORGANIZATIONS_FILTERED_GET_SUCCESS: {
      const organizations = get(action, 'payload', {});
      return {
        ...state,
        organizations,
        errors: [],
        isCategoryApisError: false,
        isLoading: false,
      };
    }
    case Constants.TEMPLATE_CATEGORY_APIS_ACCESS_ORGANIZATIONS_FILTERED_GET_ERROR: {
      return {
        ...state,
        isLoading: false,
        isCategoryApisError: true,
        organizations: {},
        validationErrors: action.payload,
      };
    }
    case Constants.TEMPLATE_CATEGORY_LIST_ORDER_REQUEST:
      return {
        ...state,
        isLoading: true,
        templatesOrderUpdateResult: Constants.NONE,
      };
    case Constants.TEMPLATE_CATEGORY_LIST_ORDER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        templatesOrderUpdateResult: Constants.SUCCESS,
      };
    case Constants.TEMPLATE_CATEGORY_LIST_ORDER_ERROR:
      return {
        ...state,
        isLoading: false,
        templatesOrderUpdateResult: Constants.FAIL,
      };
    case Constants.TEMPLATE_CATEGORY_GET_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        isTemplateCategoriesLoaded: false,
        templateCategories: [],
        validationErrors: [],
      };
    case Constants.TEMPLATE_CATEGORY_GET_LIST_SUCCESS:
      return {
        ...state,
        templateCategories: action.payload,
        isLoading: false,
        isTemplateCategoriesLoaded: true,
      };
    case Constants.TEMPLATE_CATEGORY_GET_LIST_ERROR:
      return {
        ...state,
        isListError: Constants.FAIL,
        isLoading: false,
        validationErrors: action.payload,
        isTemplateCategoriesLoaded: true,
      };
    case Constants.API_APPLICABLE_TEMPLATE_CATEGORY_GET_LIST_REQUEST:
      return {
        ...state,
        apiApplicableTemplateCategories: [],
        validationErrors: [],
      };
    case Constants.API_APPLICABLE_TEMPLATE_CATEGORY_GET_LIST_SUCCESS:
      return {
        ...state,
        apiApplicableTemplateCategories: action.payload,
        isAPIApplicableTemplateCategoriesLoaded: true,
      };
    case Constants.API_APPLICABLE_TEMPLATE_CATEGORY_GET_LIST_ERROR:
      return {
        ...state,
        apiApplicableTemplateCategories: [],
        isAPIApplicableTemplateCategoriesLoaded: true,
        isListError: Constants.FAIL,
        validationErrors: action.payload,
      };
    case Constants.TEMPLATE_CATEGORY_ORGANIZATIONS_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errors: [],
        isError: false,
        categoryOrgs: action.payload,
      };
    case Constants.TEMPLATE_CATEGORY_ORGANIZATIONS_GET_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
        validationErrors: action.payload,
      };
      case Constants.TEMPLATE_CATEGORY_ORGANIZATIONS_UPDATE_SUCCESS:
        return {
          ...state,
          isLoading: false,
          errors: [],
          isError: false,
          isCategoryOrgUpdateSuccess: 'SUCCESS',
        };
    case Constants.TEMPLATE_CATEGORY_ORGANIZATIONS_UPDATE_ERROR:
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
        isError: true,
        validationErrors: action.payload,
        isCategoryOrgUpdateSuccess: 'ERROR',
      };
    case Constants.TEMPLATE_CATEGORY_ORGANIZATIONS_UPDATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        isCategoryOrgUpdateSuccess: null,
      };
    case Constants.TEMPLATE_CATEGORY_GET_DETAILS_SUCCESS:
      return {
        ...state,
        templateCategoriesDetailsMap: {
          ...state.templateCategoriesDetailsMap,
          [action.categoryId]: action.payload,
        },
      };
    case Constants.TEMPLATE_CATEGORY_GET_DETAILS_ERROR:
      return {
        ...state,
        templateCategoriesDetailsMap: {
          ...state.templateCategoriesDetailsMap,
          [action.categoryId]: {},
        },
      };
    default:
      return state;
  }
}

export const getIsLoading = (state) => get(state, 'templateCategory.isLoading');
export const getDetails = state => get(state, 'templateCategory.details');
export const getFetchResult = state => get(state, 'templateCategory.fetchResult');
export const getCreateResult = state => get(state, 'templateCategory.createResult');
export const getCreatedCategory = state => get(state, 'templateCategory.createdTC');
export const getUpdateResult = state => get(state, 'templateCategory.updateResult');
export const getDeleteResult = state => get(state, 'templateCategory.deleteResult');
export const getValidationErrors = (state) => get(state, 'templateCategory.validationErrors');
export const getPolicyTemplates = state => get(state, 'templateCategory.policyTemplates');
export const getCategoryTemplates = state => get(state, 'templateCategory.categoryTemplates');
export const getCategoryApisAccess = state => get(state, 'templateCategory.categoryApis');
export const getIsCategoryApisAccessError = state => get(state, 'templateCategory.isCategoryApisError');
export const getOrganizationsListResult = state => get(state, 'templateCategory.organizations.results',[]);
export const getCategoriesTemplatesMap = state => get(state, 'templateCategory.categoriesTemplatesMap');
export const getUpdateTemplatesResult = state => get(state, 'templateCategory.templatesUpdateResult');
export const getTemplatesOrderUpdateResult = state => get(state, 'templateCategory.templatesOrderUpdateResult');
export const getTemplateCategoryListResults = (state) => get(state, 'templateCategory.templateCategories');
export const getTemplateCategoriesDetailsMap = (state) => get(state, 'templateCategory.templateCategoriesDetailsMap');
export const getAPIApplicableTemplateCategoryListResults = (state) => get(state, 'templateCategory.apiApplicableTemplateCategories');
export const getIsAPIEditTemplateDataLoaded = (state) => get(state, 'templateCategory.isTemplateCategoriesLoaded')
  && get(state, 'templateCategory.isAllCategoriesTemplatesLoaded') && get(state, 'templateCategory.isAPIApplicableTemplateCategoriesLoaded');
export const getIsAccessibleTemplateCategoriesLoaded = (state) => get(state, 'templateCategory.isTemplateCategoriesLoaded');
export const getCategoryOrgs = state => get(state, 'templateCategory.categoryOrgs');
export const getCategoryOrgsUpdateSuccess = state => get(state, 'templateCategory.isCategoryOrgUpdateSuccess');

